import API from "./axios";

export const signUp = async (userDetail) => {
  try {
    const response = await API.post("syndicasia/", userDetail, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return {
      success: true,
      message:
        response.data?.message ||
        "Your account is pending approval. You will receive an email once it has been approved.",
      id: response.data?.id,
    };
  } catch (error) {
    console.error("Sign-up error:", error);

    const errorMessage =
      error.response?.data?.detail ||
      error.response?.data?.message ||
      (error.request
        ? "No response from the server. Please check your internet connection."
        : "An unexpected error occurred. Please try again.");

    return { success: false, message: errorMessage };
  }
};
